import React, { Component, useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { useDDLog, Logger, Action, message } from '../DDLogProvider'

type Props = {
  children: any
  ddLog: Logger
}

class DDErrorBoundary extends Component<Props> {
  public componentDidCatch(error, errorInfo) {
    this.props.ddLog.info(message('Page crashed'), {
      action: Action.pageCrash,
    })
    this.props.ddLog.error(errorInfo, { name: error })
  }

  public render() {
    return this.props.children;
  }
}

const DDLogger = (props) => {
  const ddLog = useDDLog()
  const { pathname } = useLocation()

  useEffect(() => {
    ddLog.info(message('Page viewed'), {
      action: Action.pageView,
    })
  }, [pathname])

  return (
    <DDErrorBoundary ddLog={ddLog}>
      {props.children}
    </DDErrorBoundary>
  )
}

export { DDLogger }
